<h4>appMode: {{appMode}}</h4>
<ng-container *ngIf="appMode === 'Antrag'">
  <lv-fondsportfolio-vermittlerspezifisch-verwaltung></lv-fondsportfolio-vermittlerspezifisch-verwaltung>
</ng-container>
<ng-container *ngIf="appMode === 'Verwaltung'">
  <lv-fondsportfolio-vermittlerspezifisch-antrag></lv-fondsportfolio-vermittlerspezifisch-antrag>
</ng-container>
